<template>
  <onboarding-camera-layout
    ref="onboarding-camera-layout"
    v-if="documentStep"
    :headerTitle="headerTitle"
    :warningMessage="warningMessage"
    :openCamera="allowToOpenCamera"
    @onTakePicture="handleTakePicture"
    @onCameraError="handleCameraError"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex';
import OnboardingCameraLayout from '../components/OnboardingCameraLayout.vue';

export default {
  name: 'v2-onboarding-documents-camera',
  data: () => ({
    headerTitle: null,
    warningMessage: null,
    documentStep: null,
  }),
  components: {
    OnboardingCameraLayout,
  },
  computed: {
    ...mapState('onboardingV2', ['routeParams', 'allowToOpenCamera']),
  },
  methods: {
    ...mapActions('onboardingV2', ['sendImage']),
    getMobileOS() {
      const { userAgent } = navigator;
      if (/android/i.test(userAgent)) {
        return 'Android';
      }
      if (/iPad|iPhone|iPod/i.test(userAgent)) {
        return 'iOS';
      }
      return 'Other';
    },
    handleCameraError(error) {
      if (error.isDeniedError) {
        const mobileOS = this.getMobileOS();
        if (mobileOS === 'Android') {
          this.$router.replace({
            name: 'v2-onboarding-error-camera-android',
            query: this.$route.query,
          });
        } else {
          this.$router.replace({
            name: 'v2-onboarding-error-camera-ios',
            query: this.$route.query,
          });
        }
      } else {
        alert('Erro inesperado, entre em contato com o nosso suporte');
        this.$router.replace({
          name: 'v2-onboarding-error',
          query: this.$route.query,
        });
      }
      console.log(error);
    },
    async handleTakePicture(base64Img) {
      const { success, message } = await this.sendImage({ base64Img });
      await this.$refs['onboarding-camera-layout'].stopLoading({
        success,
        timeout: 1500,
        message,
      });
      await this.handleNextStep();
    },
    async handleNextStep() {
      const { documentStep } = this.routeParams || {};
      if (['frontdoc', 'backdoc'].includes(documentStep)) {
        this.fillComponentInfoByStep({ documentStep });
        await this.$router.replace({
          name: 'v2-onboarding-documents-camera',
          params: { documentStep },
          query: this.$route.query,
        });
        return;
      }

      this.$refs['onboarding-camera-layout'].closeCamera();
      await this.$router.replace({
        name: 'v2-onboarding-selfie',
        query: this.$route.query,
      });
    },
    fillComponentInfoByStep({ documentStep }) {
      this.documentStep = documentStep;
      if (documentStep === 'frontdoc') {
        this.headerTitle = 'Frente do documento';
        this.warningMessage = 'Tire a foto da FRENTE do documento';
      } else {
        this.headerTitle = 'Verso do documento';
        this.warningMessage = 'Tire a foto do VERSO do documento';
      }
    },
  },
  mounted() {
    const { documentStep } = this.$route.params;
    this.fillComponentInfoByStep({ documentStep });
  },
};
</script>

<style lang="scss" scoped>
</style>
